@if (gallery()) {
  <div class="dialog">
    <div class="header">
      <button
        appButton
        name="back"
        location="embed-gallery-dialog"
        [iconButton]="true"
        color="simple-gray"
        height="0"
        (click)="onBack()"
      >
        <app-svg src="/assets/icons/arrow-left.svg"></app-svg>
      </button>
      <h1>Embed Gallery</h1>
    </div>

    @if (gallery().password_enabled) {
      <app-warning-box
        title="Active Password"
        message="Remove the password to embed this gallery."
        ctaText="Manage"
        (onClick)="manageLink()"
      ></app-warning-box>
    }

    <div [class.disabled]="gallery().password_enabled">
      <div class="logos">
        <img src="/assets/icons/logo/shopify-color.svg" alt="" draggable="false" />
        <img src="/assets/icons/logo/squarespace-color.svg" draggable="false" alt="" />
        <img src="/assets/icons/logo/webflow-color.svg" draggable="false" alt="" />
        <img src="/assets/icons/logo/wordpress-color.svg" draggable="false" alt="" />
        <img src="/assets/icons/logo/wix-color.svg" draggable="false" alt="" />
        <img src="/assets/icons/logo/notion-color.svg" draggable="false" alt="" />

        <div class="separator"></div>

        <a
          href="https://help.picflow.com/en/articles/10441758"
          target="_blank"
          appButton
          name="all-platforms"
          location="embed-galery-dialog"
          color="simple-gray"
          height="0"
          size="1"
          [hasIcon]="true"
        >
          <span>All Platforms</span>
          <app-svg src="/assets/icons/16/arrow-external.svg" size="-1"></app-svg>
        </a>
      </div>

      <div class="fake-textarea">
        {{ embedCode() }}
      </div>
      <div class="embed-footer">
        <app-context-menu [options]="{ width: '240px', noSpacing: true }" verticalPosition="top" #colorPickerMenu>
          <div contextContent>
            <app-color-picker
              [(color)]="newOptions().lightboxColor"
              [allowOpacity]="true"
              (colorChange)="onEmbedChange()"
            >
            </app-color-picker>
          </div>
        </app-context-menu>
        <app-context-menu [options]="{ width: '260px', noSpacing: true }">
          <button
            appButton
            name="embed-settings"
            location="embed-gallery-dialog"
            color="simple"
            weight="bold"
            [hasIcon]="true"
            contextButton
          >
            <span>Embed Settings</span>
            <app-svg src="/assets/icons/chevron-down.svg" size="0"></app-svg>
          </button>
          <div contextContent>
            <div class="embed-settings-box">
              <label for="option-lightbox" class="embed-option">
                <div>Media Lightbox</div>
                <app-switch [small]="true">
                  <input
                    type="checkbox"
                    id="option-lightbox"
                    [(ngModel)]="newOptions().lightbox"
                    (ngModelChange)="onEmbedChange()"
                    appClickTrack
                    name="lightbox"
                    location="embed-gallery-dialog"
                    [extra]="{ value: newOptions().lightbox }"
                  />
                  <label for="option-lightbox" data-test-id="option-lightbox"></label>
                </app-switch>
              </label>

              @if (newOptions().lightbox) {
                <button
                  appButton
                  name="lightbox-color"
                  spacing="1"
                  fullWidth="true"
                  location="embed-gallery-dialog"
                  (click)="colorPickerMenu.open()"
                  color="simple"
                  class="lightbox-color"
                >
                  <span>Lightbox Color</span>
                  <img src="/assets/rainbow-circle.png" alt="" />
                </button>
              }
              <label for="option-cover" class="embed-option">
                <div>Show Cover</div>
                <app-switch [small]="true">
                  <input
                    type="checkbox"
                    id="option-cover"
                    [(ngModel)]="newOptions().showCover"
                    (ngModelChange)="onEmbedChange()"
                    appClickTrack
                    name="show-cover"
                    location="embed-gallery-dialog"
                    [extra]="{ value: newOptions().showCover }"
                  />
                  <label for="option-cover" data-test-id="option-cover"></label>
                </app-switch>
              </label>
              <label for="option-padding" class="embed-option">
                <div>Remove Padding</div>
                <app-switch [small]="true">
                  <input
                    type="checkbox"
                    id="option-padding"
                    [(ngModel)]="newOptions().noPadding"
                    (ngModelChange)="onEmbedChange()"
                    appClickTrack
                    name="remove-padding"
                    location="embed-gallery-dialog"
                    [extra]="{ value: newOptions().noPadding }"
                  />
                  <label for="option-padding" data-test-id="option-padding"></label>
                </app-switch>
              </label>
              <label for="option-background" class="embed-option">
                <div>Remove Background</div>
                <app-switch [small]="true">
                  <input
                    type="checkbox"
                    id="option-background"
                    [(ngModel)]="newOptions().noBackground"
                    (ngModelChange)="onEmbedChange()"
                    appClickTrack
                    name="remove-background"
                    location="embed-gallery-dialog"
                    [extra]="{ value: newOptions().noBackground }"
                  />
                  <label for="option-background" data-test-id="option-background"></label>
                </app-switch>
              </label>
            </div>

            <div class="divider"></div>

            <div class="embed-settings-box">
              @if (newOptions().lightbox) {
                <label for="option-downloads" class="embed-option">
                  <div>Allow Downloads</div>
                  @if ('gallery:download-from-embed' | billingScope) {
                    <app-switch [small]="true">
                      @if (!gallery().download_single_asset) {
                        <!--Disabled-->
                        <input disabled type="checkbox" />
                      } @else {
                        <!--Enabled-->
                        <input
                          type="checkbox"
                          id="option-downloads"
                          [(ngModel)]="newOptions().allowDownloads"
                          (ngModelChange)="onEmbedChange()"
                          appClickTrack
                          name="allow-downloads"
                          location="embed-gallery-dialog"
                          [extra]="{ value: newOptions().allowDownloads }"
                        />
                      }
                      <label for="option-downloads" data-test-id="option-downloads"></label>
                    </app-switch>
                  } @else {
                    <app-upgrade-badge
                      location="embed-gallery-dialog"
                      scope="gallery:download-from-embed"
                    ></app-upgrade-badge>
                  }
                </label>
              }

              <label for="option-right-click-protect" class="embed-option">
                <div>Right-Click Protect</div>
                @if ('asset:embed-right-click-protection' | billingScope) {
                  <app-switch [small]="true">
                    <input
                      type="checkbox"
                      id="option-right-click-protect"
                      [(ngModel)]="newOptions().rightClickProtection"
                      (ngModelChange)="onEmbedChange()"
                      appClickTrack
                      name="right-click-protection"
                      location="embed-gallery-dialog"
                      [extra]="{ value: newOptions().rightClickProtection }"
                    />
                    <label for="option-right-click-protect" data-test-id="option-right-click-protect"></label>
                  </app-switch>
                } @else {
                  <app-upgrade-badge
                    location="embed-gallery-dialog"
                    scope="asset:embed-right-click-protection"
                  ></app-upgrade-badge>
                }
              </label>
            </div>
          </div>
        </app-context-menu>
        <div class="spacer"></div>
        <button
          appButton
          name="copy-embed"
          location="embed-gallery-dialog"
          [color]="gallery().password_enabled ? 'grey-50' : 'primary'"
          [share]="embedCode()"
          (onCopied)="onCopy()"
          height="3"
          shape="round"
          size="3"
          weight="bold"
          spacing="4"
          [class.disabled]="
            gallery().public_access === 'no_access' || (gallery().tenant || activeTenant())['block_public_link_access']
          "
        >
          Copy
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="dialog loading">
    <app-loading-indicator size="small"></app-loading-indicator>
  </div>
}
